import "./App.css";
import Baseball from "./components/Baseball";
import { Provider } from "react-redux";
import playersStore from "./store/players";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Resume from "./components/resume/Resume";
import Football from "./components/football/Football";
import Home from "./components/home/Home";

const router = createBrowserRouter([
  {path: "mlb", element: <Provider store={playersStore}><Baseball /></Provider>},
  {path: "resume", element: <Resume />},
  {path: "nfl", element: <Football />},
  {path: "/", element: <Home />}
])

function App() {
  return <RouterProvider router={router} />;
}

export default App;
